import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

import { KHATTABAT_MATCHING_RESULTS_LIMIT } from "../../../../../constants/picker-entries-constants";
import i18n from "../../../../../constants/i18n";
import { KHATTABAT_MATCHING_FIELD_SIZE } from "../../../../../constants/user-profile";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import FilterSelect from "./FilterSelect";

const FormActions = withLiteObserverAndTheme(() => {
  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
          <FilterSelect
            label={i18n.get("RESULTS_NUMBER")}
            options={KHATTABAT_MATCHING_RESULTS_LIMIT}
            value={getKhattabatMatchingStore().matchesIdsResultLimit.get()}
            onChange={getKhattabatMatchingStore().setMatchesIdsResultLimit}
          />
        </Grid>
        <Grid size="grow">
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button
              variant="outlined"
              color="error"
              disabled={!getKhattabatMatchingStore().isActiveFilter.get()}
              onClick={() => getKhattabatMatchingStore().resetFilter()}
            >
              {i18n.get("CLEAR_RESULTS")}
            </Button>
            <Button
              variant="contained"
              disabled={!getKhattabatMatchingStore().canGetMatches()}
              onClick={async () => {
                await getKhattabatMatchingStore().getMatchesIds();
              }}
            >
              {i18n.get("GET")}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
});

export default FormActions;
